import { Component, Input, OnInit, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { CommonService } from '../../service/common/common.service';

@Component({
  selector: 'editor-duties',
  templateUrl: './editor-duties.component.html',
  styleUrls: ['./editor-duties.component.less', '/src/styles/form.less', '/src/styles/organ/depart.less'],
})
export class EditorDutiesComponent implements OnInit {
  /**
   * 岗位信息
   */
  @Input() duties: object = {
    job_name: '',
    job_id: 0,
    templete_job_id: 0,
    is_admin: 0,
  };
  /**
   * 操作类型 create 新增岗位 editor 编辑岗位
   */
  @Input() type: string = 'create';
  /**
   * 岗位模板列表
   */
  @Input() dutiesTpl: Array<object> = [];
  /**
   * 显示开关
   */
  @Input() show: boolean = false;
  /**
   * 岗位用人标尺
   */
  @Input() standard: Array<object> = [];
  @Output() cancel = new EventEmitter();
  @Output() sure = new EventEmitter();
  @Output() toTpl = new EventEmitter();
  /**
   * 岗位添加方式 true 岗位模板  false  自建
   */
  dutiesType: boolean = true;
  dutiesTypeOptions = [
    { title: '岗位模板选择', value: true },
    { title: '创建岗位', value: false },
  ];
  templete_id: Array<any> = [];
  /**
   * 岗位信息源数据
   */
  sourceDuties: object = {};

  constructor(private common: CommonService) {
  }

  ngOnInit(): void {
    console.log(this.dutiesTpl);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['duties'] != undefined) {
      this.sourceDuties = { ...this.duties };
    }
  }

  /**
   * 关闭弹窗
   */
  cancelEditorDuties(): void {
    // this.dutiesType = false;
    this.cancel.emit({ event: 'cancel', target: {} });
    this.reset();
  }

  /**
   * 确认操作
   */
  editorDuties(): void {
    if (this.dutiesTpl.length == 0) {
      this.jumpToTpl();
      return;
    }
    let validate: boolean = true;
    if (this.type == 'create') {  // 判断是创建
      if (!this.dutiesType) { // 判断是自建
        // if (this.duties['job_name'] == '') { // 判断岗位名称是否填写
        //   console.log(11111)
        //   validate = false;
        // }
        // if (this.duties['rule_id'] == '') { // 判断岗位标尺是否选择
        //   console.log(222222)
        //   validate = false;
        // }
      } else {// 判断是采用岗位模板
        this.duties['templete_job_id'] = this.templete_id.join(',');
        if (this.duties['templete_job_id'] == '') {
          validate = false;
        }
      }
    } else { // 判断是编辑
      // if (this.duties['job_name'] == '') { // 判断岗位名称是否填写
      //   validate = false;
      // }
      // if (this.duties['rule_id'] == '') { // 判断岗位标尺是否选择
      //   validate = false;
      // }
    }

    if (!validate) {
      this.common.msg.error('请完善岗位信息!');
      return;
    }
    this.sure.emit({ event: 'sure', target: this.duties });
    // this.dutiesType = false;
    // 重置表单数据
    this.reset();
  }

  checkTplType($event: any): void {
    // 重置表单数据
    this.reset();
  }

  /**
   * 设置为管理岗位
   * @param $event
   */
  setAdminDuties($event: any): void {
    this.duties['is_admin'] = $event ? 1 : 0;
  }

  /**
   * 选择岗位模板
   */
  checkTpl(event: any): void {
    // 如果选择的岗位模板数量大于1个 则当前创建的所有岗位都不可以设置为管理岗
    if (this.templete_id.length > 1) {
      this.duties['is_admin'] = 0;
    }
  }

  private reset(): void {
    this.templete_id = [];
  }

  /**
   * 跳转到当前类型下的岗位模板界面
   */
  jumpToTpl(): void {
    console.log(1111111);
    this.toTpl.emit({ event: 'jump', target: {} });
  }

  /**
   * checkBox 选择模板岗位
   * @param id
   */
  checkBoxChange(id: any): void {
    // 判断此id是否被选中 如果选中则移除 没选中则添加
    const _templete_id = [...this.templete_id];
    console.log(id, _templete_id);

    if (this.templete_id.indexOf(id) > -1) {
      _templete_id.splice(this.templete_id.indexOf(id), 1);
    } else {
      _templete_id.push(id);
    }
    this.templete_id = [..._templete_id];
    console.log(this.templete_id);
  }
}
